import { IngestMetadata } from "datasets/pages/tables/types/interfaces/ingest";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const useFileMetadata = (sourceFile?: string) => {
  const key = sourceFile
    ? `${VITE_CATALOG_API}/ingests/metadata/load?metadata_platform_storage_key=${sourceFile}`
    : null;

  return useFetcher<IngestMetadata>(key, {
    onError: (error) => {
      const body = JSON.parse(error.message);
      if (body.detail) {
        error.message = body.detail;

        return error;
      }
    },
    onErrorRetry: (error) => {
      if (error.status === 404) {
        return;
      }
    },
  });
};

export default useFileMetadata;
